import './Footer.scss';

import logo from "../resources/images/logo-words.svg";
import { Button } from "./Reusable"

function Footer() {
    let currentYear = new Date().getFullYear()

    return (
        <>
            <div className="Footer" id="Footer">
                <div className='Footer-container left'>
                    <img src={logo} alt="Candlelyte logo" loading="lazy" decoding="async" />
                    <span>&copy; {currentYear}, Candlelyte Productions. All rights reserved.</span>
                </div>
                <div className="Footer-container right">
                    <h2>Want a quote?</h2>
                    <p>Get in touch today and let’s talk about how we can tell your story.</p>
                    <Button title="Get in touch" flameon={true} source="Footer" />
                </div>
            </div>
        </>
    );
}

export default Footer;
